/* eslint-disable no-restricted-syntax */
/* eslint-disable no-loop-func */
/* eslint-disable no-plusplus */
/* eslint-disable no-undef */
import { ApiHttpService } from '../ApiHttpService';
import { ShippingOptionSerializer } from '../serializers/ShippingOptionSerializer';
import { ShippingOptionsByLocationSerializer } from '../serializers/ShippingOptionsByLocationSerializer';
import { ShippingOption } from '../../models/ShippingOption';
import { ShippingOptionsByLocation } from '../../models/ShippingOptionsByLocation';
import { assignFutureDates } from '../../helpers/NextDateHelper';

const SHIPPING_PATH = 'usuario/OpcionesDeFletes';
const SHIPPING_LOCATION_PATH = 'usuario/OpcionesDeFletesLocalidad';

class ShippingOptionsController {
  static async all(addressId, cart, nextDate, locationKey) {
    const authenticated = true;
    const params = {
      IDDIreccion: addressId,
      Carrito: cart.map(item => ({
        key: item.productId,
        value: item.amount,
      })),
    };
    const response = await ApiHttpService.post(SHIPPING_PATH, params, authenticated);
    let deSerializedShippingOptions = response.data;
    deSerializedShippingOptions = ShippingOptionSerializer.deSerialize(deSerializedShippingOptions);
    let shippingOptions = deSerializedShippingOptions.map(option => new ShippingOption(option));
    if (nextDate) {
      shippingOptions = assignFutureDates(shippingOptions, nextDate, locationKey);
    }

    return shippingOptions;
  }

  static async getByLocation(location) {
    const params = {
      localidad: location,
    };
    const response = await ApiHttpService.get(SHIPPING_LOCATION_PATH, params);
    let deSerializedShippingOptions = response.data;
    let shippingOptions = {};
    if (deSerializedShippingOptions) {
      deSerializedShippingOptions = ShippingOptionsByLocationSerializer
        .deSerialize(deSerializedShippingOptions);
      shippingOptions = new ShippingOptionsByLocation(deSerializedShippingOptions);
    }
    return shippingOptions;
  }
}

export { ShippingOptionsController };



// WEBPACK FOOTER //
// ./src/networking/controllers/ShippingOptionsController.js